import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface StepCardProps {
  step: number;
  title: string;
  description: string;
  icon: LucideIcon;
  children?: React.ReactNode;
}

export const StepCard: React.FC<StepCardProps> = ({ step, title, description, icon: Icon, children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-2xl p-6 shadow-xl relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-red-50 rounded-full -translate-x-16 -translate-y-16 opacity-50" />
      
      <div className="relative">
        {/* Step number */}
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3">
            <span className="text-red-600 font-bold">{step}</span>
          </div>
          <Icon className="w-6 h-6 text-red-600 mr-2" />
          <h3 className="text-xl font-bold text-gray-900">{title}</h3>
        </div>

        {/* Description */}
        <p className="text-gray-600 mb-6">{description}</p>

        {/* Additional content (e.g., character grid, video comparison) */}
        {children}
      </div>
    </motion.div>
  );
};